import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Title from '../Title';

const useStyles = makeStyles(theme => ({
  root: {
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginBottom: 5,
      paddingRight: 0,
    },
  },
  title: {
    [theme.breakpoints.down('xs')]: {
      flexGrow: 1,
      flexBasis: 0,
      marginRight: 10,
      lineHeight: 1.1,
    },
    '& span': {
      lineHeight: 1.1,
    },
  },
  content: {
    whiteSpace: 'pre-wrap',
    [theme.breakpoints.down('xs')]: {
      flexGrow: 3,
      flexBasis: 0,
      lineHeight: 1.3,
      '& div': {
        lineHeight: 1.3,
      },
    },
  },
}));

const TitledBlock = ({ children, className, contentClass, title, titleSize, titleColor, titleClass }) => {
  const classes = useStyles();

  return (
    <Grid item className={classnames(classes.root, className)}>
      <Grid className={classnames(classes.title, titleClass)}>
        <Title size={titleSize} color={titleColor}>
          {title}
        </Title>
      </Grid>
      <Grid className={classnames(classes.content, contentClass)}>{children}</Grid>
    </Grid>
  );
};

TitledBlock.propTypes = {
  title: PropTypes.string.isRequired,
  titleSize: Title.propTypes.size,
  children: PropTypes.node,
  className: PropTypes.string,
  contentClass: PropTypes.string,
  titleClass: PropTypes.string,
};

TitledBlock.defaultProps = {
  titleSize: 'small',
};

export default TitledBlock;
